module.exports = __webpack_public_path__ + "media/bannerly.a2d9b271.mp4";